import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { ConfigService } from './core/services/config.service';
import { KeycloakService, KeycloakBearerInterceptor } from 'keycloak-angular';
import { CustomSocket } from './core/services/custom-socket.service';
import { authErrorInterceptor } from './core/interceptors/auth-interceptor';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([authErrorInterceptor])),
    KeycloakService,
    CustomSocket,
    provideAppInitializer(async () => {
      try {
        const keycloak = inject(KeycloakService);
        const configService = inject(ConfigService);
        const socket = inject(CustomSocket);
        await configService.loadConfig();

        if (configService.config?.configKeycloak) {
          if (configService.config.configKeycloak.initOptions) {
            const silentCheckSsoRedirectUri = `${window.location.origin}/assets/silent-check-sso.html`;
            configService.config.configKeycloak.initOptions.silentCheckSsoRedirectUri = silentCheckSsoRedirectUri;
          }
          await keycloak.init(configService.config.configKeycloak);
        }
        socket.connect();
      } catch (error) {
        console.error('Initialization failed', error);
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es-AR' },
  ],
};
